import { useOrganizationId } from './useOrganizationId';
import { useUserOrganizationId } from './useUserOrganizationId';

// Case applies only to buyers (parents linked to children via claims)
export const useNCAParentOrganizationId = () => {
  const buyerOrganizationId = useUserOrganizationId();
  const currentNcaOrganizationId = useOrganizationId();
  return buyerOrganizationId !== currentNcaOrganizationId ? currentNcaOrganizationId : null;
};
